module.exports = __webpack_public_path__ + "static/media/27.c7c77031.jpg";